module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create club","clubsActionsCreateSuccess":"%{clubsName} was successfully added to the database"},"no":{"dialogTitle":"Opprett klubb","clubsActionsCreateSuccess":"%{clubsName} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
